import { Reveal } from "./Reveal";

const testimonials = [
  {
    quote:
      "Je repoussais toujours l’heure du coucher à force de scroller. En trois semaines, j’ai retrouvé un vrai rituel du soir. Je m’endors sans mon téléphone, enfin.",
    name: "Camille R.",
    role: "Lyon · 34 ans",
  },
  {
    quote:
      "Les relaxations audio sont devenues mon moment préféré de la journée. La voix est douce, jamais niaise. Mes réveils nocturnes ont vraiment diminué.",
    name: "Thomas L.",
    role: "Nantes · 41 ans",
  },
  {
    quote:
      "Ce que j’aime, c’est la progressivité. Rien n’est imposé, on avance nuit après nuit. Trois semaines plus tard, je me réveille reposée pour la première fois depuis des années.",
    name: "Inès M.",
    role: "Bordeaux · 29 ans",
  },
];

export const Testimonials = () => {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative mx-auto max-w-6xl scroll-mt-24 px-6 py-24 md:py-32 lg:px-10"
    >
      <Reveal className="mb-16 text-center">
        <p className="mb-5 text-xs font-semibold uppercase tracking-[0.3em] text-[#c9a84c]">
          Elles & ils dorment mieux
        </p>
        <h2 className="mx-auto max-w-2xl text-4xl font-light leading-tight tracking-tight sm:text-5xl">
          Des soirées qui ont changé
        </h2>
      </Reveal>

      <div className="grid gap-6 md:grid-cols-3">
        {testimonials.map((t, i) => (
          <Reveal
            key={t.name}
            delay={i * 0.12}
            className="card-line flex flex-col rounded-2xl border border-white/8 bg-[#1e1535] p-8"
          >
            <span className="font-serif text-5xl leading-none text-[#c9a84c]/50">
              “
            </span>
            <p className="mt-4 flex-1 text-base font-light leading-relaxed text-white/80">
              {t.quote}
            </p>
            <div className="mt-8 border-t border-white/8 pt-5">
              <p className="text-sm font-medium text-white">{t.name}</p>
              <p className="mt-0.5 text-xs uppercase tracking-wider text-white/40">
                {t.role}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
};
